var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 5120 5120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l5RmJohA39t6Tlnj21ekmyw",
    fill: "#f58220",
    style: {
      transform: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1Fm66ZzfR",
    d: "M2405 5109 c-578 -32 -1139 -272 -1572 -671 -447 -413 -728 -956 -808 -1563 -21 -159 -21 -471 0 -630 38 -289 119 -556 245 -810 383 -775 1112 -1295 1975 -1410 143 -19 457 -22 595 -5 460 56 898 230 1254 500 553 419 910 1035 1001 1725 10 74 16 195 16 315 0 300 -37 527 -130 810 -216 651 -699 1196 -1327 1496 -281 135 -620 225 -898 239 -55 3 -126 7 -156 9 -30 1 -118 -1 -195 -5z m375 -1714 l0 -745 210 0 209 0 5 -32 c9 -54 46 -433 46 -467 l0 -31 -230 0 -230 0 0 -174 c0 -96 4 -186 10 -200 5 -14 24 -35 42 -46 30 -18 51 -20 221 -20 l187 0 0 -261 0 -261 -312 4 c-346 5 -360 7 -490 75 -73 38 -158 120 -201 193 -14 25 -38 81 -53 125 -27 77 -28 88 -32 322 l-4 242 -146 3 -147 3 -3 263 -2 262 150 0 150 0 0 745 0 745 310 0 310 0 0 -745z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6bb44ce8fa82538c142c95701d758971.svg";
export { ForwardRef as ReactComponent };